'use client';

import { ActionIcon, Indicator } from '@mantine/core';
import { IconShoppingCart } from '@tabler/icons-react';
import Link from 'next/link';

export function CartButton({
  authed,
  cartItems,
  onModalOpen,
}: {
  authed: boolean;
  cartItems: number;
  onModalOpen: () => void;
}) {
  if (!authed) {
    return (
      <ActionIcon size="xl" variant="light" onClick={onModalOpen}>
        <IconShoppingCart />
      </ActionIcon>
    );
  }

  return (
    <Indicator offset={6} size={18} label={cartItems} disabled={!authed}>
      <ActionIcon size="xl" variant="light" href="/cart" component={Link}>
        <IconShoppingCart />
      </ActionIcon>
    </Indicator>
  );
}
